import type { HTMLAttributes, ReactElement, SVGProps } from 'react'
import * as S from './styled'

interface LoaderProps extends HTMLAttributes<HTMLDivElement> {
  show?: boolean
  message?: string
  transparent?: boolean
  localPosition?: boolean
  fill?: string
  /**
   * Animation speed rate. Default: 1.5/{rate}
   */
  speed?: number
}

type IconProps = SVGProps<SVGSVGElement> &
  Pick<LoaderProps, 'fill' | 'speed'> & {
    pathProps?: SVGProps<SVGPathElement>
  }

export const LoadingIcon = ({ fill, speed, pathProps, ...props }: IconProps) => (
  <S.StyledSVG
    xmlns={'http://www.w3.org/2000/svg'}
    width={48}
    height={48}
    viewBox={'0 0 24 24'}
    fill={'none'}
    $fill={fill}
    $speed={speed}
    {...props}
  >
    <path
      className={'icon-path'}
      d={
        'M12 2V6M12 18V22M4.93 4.93L7.76 7.76M16.24 16.24L19.07 19.07M2 12H6M18 12H22M4.93 19.07L7.76 16.24M16.24 7.76L19.07 4.93'
      }
      strokeWidth={'1.5'}
      strokeLinecap={'round'}
      strokeLinejoin={'round'}
      {...pathProps}
    />
  </S.StyledSVG>
)

export const Loader = ({
  show = true,
  message,
  transparent = false,
  fill,
  speed,
  localPosition = false,
}: LoaderProps): ReactElement | null => {
  if (!show) return null

  return (
    <S.StyledSpinner
      id={!localPosition ? 'loading-element' : ''}
      $transparent={transparent}
      $localPosition={localPosition}
    >
      <LoadingIcon fill={fill} speed={speed} />
      {!localPosition && message && <S.Message>{message}</S.Message>}
    </S.StyledSpinner>
  )
}
